import { render, staticRenderFns } from "./CmgHeaderHamburgerIcon.vue?vue&type=template&id=2f072c2b&scoped=true&lang=pug&"
import script from "./cmg-header-hamburger-icon.ts?vue&type=script&lang=ts&"
export * from "./cmg-header-hamburger-icon.ts?vue&type=script&lang=ts&"
import style0 from "./CmgHeaderHamburgerIcon.vue?vue&type=style&index=0&id=2f072c2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f072c2b",
  null
  
)

export default component.exports